import { LDFlagSet, useFlags } from 'launchdarkly-react-client-sdk';

export interface ExpressableFlags extends LDFlagSet {
  signupShowLandingPage: boolean;
}

export const useLDFlags = () => useFlags<ExpressableFlags>();
